import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from "@material-ui/core/Divider";
import Navbar from '../navbar/Navbar'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import Footer from '../footer/footer'
import { Link } from "react-router-dom";


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

export default function ControlledExpansionPanels() {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    
    
    return (
        <div className={classes.root}>
            <Navbar />
            <Link id='back' to="/QuestionBank">
                <Button style={{ margin: '10px',marginTop:'70px'  }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
            <h1 id='desc' style={{textAlign:'center'}}>Fifth sem CSE/ISE QB</h1>
   

            <ExpansionPanel expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ marginTop: '40px' }}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography  className={classes.heading}>M.E</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> QUESTION BANK <br/>

                     
            <a href="https://drive.google.com/file/d/1RQiEsuQmpWVzvWAHeaHJxzJlDjNnhzDw/view?usp=sharing"> Module 1 </a> <br/>
            <a href="https://drive.google.com/file/d/1mLBpJ3VpKsfSyFmTtTdlefm0G0KyLqn3/view?usp=sharing"> Module 2 </a> <br/>
            <a href="https://drive.google.com/file/d/1a3XmdkOi9bHVzxP86efE2KiQxpHHpRM3/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/1f7g3iqn9CAJ43sFWmaP6wcLilB4_nA77/view?usp=sharing"> Module 4 </a> <br/>
            <a href="https://drive.google.com/file/d/1aewdOAkxnVR-YqDqfmKy10K6ab3TWT3G/view?usp=sharing"> few more </a> <br/>
                           
                        </div>
                    </Typography>
                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1wwdMV5NqWbx7Fr5A-uFfWGvYm_HgGOa7/view?usp=sharing">
                Jan 2020
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/15W0g4BvGVIVWV2Nj5xZH59vsHWb9hwFB/view?usp=sharing">
                Jan 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1SBlC7GUxN7fwsYStP4p8tGpUgDLe_1CD/view?usp=sharing">
                June 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1xStFiiEHeL8rhnOp4DTNGyPs5tBiPj-B/view?usp=sharing"
                target="_blank"
              >
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1CkQk2caiIE4PGxFB3HubTFDxTLx_LO9g/view?usp=sharing"
                target="_blank"
              >
                June 2018
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography className={classes.heading}>C.N</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> QUESTION BANK <br/>

                                 
                    <a href="https://drive.google.com/file/d/1F2ew8-m-IA-9kIHkInU3sz1EnBEPniL8/view?usp=sharing"> Module 1 </a> <br/>
            <a href="https://drive.google.com/file/d/1JYbZEcs0VEQZi73efg1nwcnozNtzcAjX/view?usp=sharing"> Module 2 </a> <br/>
            <a href="https://drive.google.com/file/d/1ZsjMCtVcwDbc8Uci5QNHHbYygQTZgVOO/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/16x1tqtLBAQBRJ7JprAQEjQuSfTMHkyCw/view?usp=sharing"> Module 4 </a> <br/>
            <a href="https://drive.google.com/file/d/12jh0D8QDxRu0vNTyYfUTfYFuv0cNJokR/view?usp=sharing"> Module 5 </a> <br/>
                       
                          
                        </div>
                    </Typography>
                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1xRH-mayE1WUIl6K4HlBYsK8mvJikxWeR/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1q1EvfjlUDcaZoGeRqwftjqrKSWilamhz/view?usp=sharing">
                June 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1_EjvnW_-LjCQs5D5pfQBMBgXUlfcKobb/view?usp=sharing">
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1YLmB8vEHHPsXzA4R0xfRskZe_NEWu0rA/view?usp=sharing"
                target="_blank"
              >
                June 2018
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className={classes.heading}>DBMS</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}> QUESTION BANK <br/>
                        
                  
            <a href="https://drive.google.com/file/d/1D9frRwAxv_6ri_7gnpcQz2WXGNEaWsdO/view?usp=sharing"> Module 1 </a> <br/>
            <a href="https://drive.google.com/file/d/1QeaCo7Aj-288fkN1lsm1HElZW4Ru7j2q/view?usp=sharing"> Module 2 </a> <br/>
            <a href="https://drive.google.com/file/d/1xbESLfF70xEbXTgue04UuFnYknEf263k/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/1nGFA5ou3HlaJT4NuHTZ1UmHUeUOcrNph/view?usp=sharing"> Module 4 </a> <br/>
            <a href="https://drive.google.com/file/d/12JCwW1mZzzjuHCewIdM58NHMLZDxAKQb/view?usp=sharing"> Module 5 </a> <br/>
                    </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1CdcjS2ELZqcHU4q8D9_yOiMnPJjndliO/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1-BsxFQ7JYY58sYMyBTtUkFqaoCfDb_85/view?usp=sharing">
                June 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1cHgCxh0qGWpoYhfxj882kp631ygpluAq/view?usp=sharing">
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1WqDhDdtmx6zh75hBHhXjyeVjvhryPOE1/view?usp=sharing"
                target="_blank"
              >
                June 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1iX3bpYuc40Wqg4Dx4a3s26tX5GT2KGzY/view?usp=sharing"
                target="_blank"
              >
                June 2017
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>ATC</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}> QUESTION BANK <br/>
                             
            <a href="https://drive.google.com/file/d/1grvkMtpbkv0ujUzoeTQb6WtHsTxcremg/view?usp=sharing"> Module 1 </a> <br/>
            <a href="https://drive.google.com/file/d/1NTsVjGGfvEdqt7r1PrT6CwqD8YshZRfl/view?usp=sharing"> Review Questions </a> <br/>
            <a href="https://drive.google.com/file/d/1SVYSl5Nno1UHSvmKI3EKIzoWaxiZ-eFa/view?usp=sharing"> Module 2 </a> <br/>
            <a href="https://drive.google.com/file/d/1FPqVAPpmW2G5h4jAGxFwd0BBa43JDmch/view?usp=sharing"> Review Questions </a> <br/>
            <a href="https://drive.google.com/file/d/11zq6qWixIHtemYSrAEWJ_PsGWYCpXilA/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/1oIxyVTD985RSdorc48fKuevcllwmY9TA/view?usp=sharing"> Review Questions  </a> <br/>
            <a href="https://drive.google.com/file/d/1dzsXSzEey9DVwRd_0jqiFG9QT9GP-458/view?usp=sharing"> Module 4 </a> <br/>
            <a href="https://drive.google.com/file/d/1BGScEbhBfsU1kSY5hhtbPo3FJNYQGQIa/view?usp=sharing"> Review Questions </a> <br/>
            <a href="https://drive.google.com/file/d/1xB0EiuYAFAoz0E4NrXkHto5CE5S6LNzs/view?usp=sharing"> Module 5 </a> <br/>
            <a href ="https://drive.google.com/file/d/13XlOb1nQbxxgVC6AyEUTgsa9COnIMUH1/view?usp=sharing">Review Questions</a><br/>
                       
                      
                     </div>
          </Typography>

          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1EVUVKFgbXufNMp2tpj6dcGbPEpNiE_a0/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1cvzbEV6yCkVJgzN8Dcfic0mYuX0MIW8h/view?usp=sharing">
                Jan 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1YXhWxb2YiOIZ2-6MIYF3KcAYM2gbqdUO/view?usp=sharing">
                June 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1V5rb0nj1SUIvOR5YwaaaKBh-YsQhh23c/view?usp=sharing"
                target="_blank"
              >
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1wgjZkD4pgyUKZO2oqSGCLR6sdskNlvGg/view?usp=sharing"
                target="_blank"
              >
                June 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1KW8ZZwXk557fUSj-hIAxEZSiPflqfGo9/view?usp=sharing"
                target="_blank"
              >
                June 2017
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>ADV JAVA & JEE</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}> QUESTION BANK <br/>

                             
                    <a href="https://drive.google.com/file/d/1CxflcMlML0C1IEcpwbb1VG8iH-WnV9tp/view?usp=sharing"> Module 1 </a> <br/>
            <a href="https://drive.google.com/file/d/1779HFyI5d8uvIkRd2uLhd4D1_PAzuTAf/view?usp=sharing"> Module 2 </a> <br/>
            <a href="https://drive.google.com/file/d/1g_KsRbwxz2kNvs_8zxRZy-sXO2kh_q-L/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/11GsCi7yRkNGZS7d_A-78djeRzxvS2FBc/view?usp=sharing"> Module 4 </a> <br/>
            <a href="https://drive.google.com/file/d/1yuZdP4pi05hno05WOlGwpcZ8M4MUYE2y/view?usp=sharing"> Module 5 </a> <br/> 
                       
                        
                    </div>
          </Typography>

          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/14RZ7g4cf25x6cAXRkjoiH6j8pm_jwV8y/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1q2E4rfSg1bE6i3ndJeE80PgNPO1oOCMc/view?usp=sharing">
                June 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1d8ngD-dyAGnCzR-OJEeG97hb6JfsVt23/view?usp=sharing">
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ZdeJrWT6ltwudVHN6hma-4uK2_YtLnYW/view?usp=sharing"
                target="_blank"
              >
                June 2018
              </a>
              <br />
             
            
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>Artificial intelligence (AI)</Typography>
                      <Typography style={{marginLeft:'30px'}} className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}>  QUESTION BANK <br/>
                             
                    <a href="https://drive.google.com/file/d/1Qz0PG086k7Glgp51N9UHgshNcXKicVVJ/view?usp=sharing"> Module 1 </a> <br/>
                   <a href="https://drive.google.com/file/d/1CekM5ln0fohqMBk96oc7WiSLUygGKlGp/view?usp=sharing"> Module 2 </a> <br/>
            <a href="https://drive.google.com/file/d/1FTtNXpRacPMuIXv2C6zMeKO5DcGUr9e1/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/1lhlADuUNDb3l7Sz5iI1Iob4jeLRgFCei/view?usp=sharing"> Module 4 </a> <br/>
            <a href="https://drive.google.com/file/d/1owJKK1nXapNcEZR9zQKRnDnwCREsm1On/view?usp=sharing"> Module 5 </a> <br/> 
                       
                      
                    </div>
          </Typography>

          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1GfKhuylX6oNKFlxVUg5GCaiHtoDvYWxu/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1lz8jhuILfzMF8DhMCaiQ4VsR2QnXzmfL/view?usp=sharing">
                June 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/140oy96UCOw19c1pBjPyiCTxnMt3XvKUs/view?usp=sharing">
                June 2018
              </a>
              <br />
             
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>.NET</Typography>
                      <Typography style={{marginLeft:'30px'}} className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}>QUESTION BANK <br/>
                             
                    <a href="https://drive.google.com/file/d/1YbTln3ak3vdTWsaqLgWwP0YqVslUdYBl/view?usp=sharing">Few Questions</a> <br/>
           {/*<a href=""> Module 2 </a> <br/>
            <a href=""> Module 3 </a> <br/>
            <a href=""> Module 4 </a> <br/>
<a href=""> Module 5 </a> <br/> */}
                       
                      
                    </div>
                    
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1gP87T55EsBSaz1yqEOdFD8ca-rj1-ADz/view?usp=sharing">
                Jan 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1I-nH_MRVZP-3GIhTyATXpVtMx-skBGfb/view?usp=sharing">
                June 2019
              </a>
              <br />
             
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>
          
            <Footer/>

            
        </div>
    );
}
